// import PropTypes from "prop-types";

import ChartkickChart from "../../../shared_components/chartkick_chart";

class CitiesVerticalChart extends ChartkickChart {
  containerStyles() {
    return {
      maxHeight: "551px",
      overflow: "auto",
      position: "relative"
    };
  }

  enableAddToSlideDeck() {
    return false;
  }
}

CitiesVerticalChart.propTypes = Object.assign({}, ChartkickChart.propTypes, {
});

export default CitiesVerticalChart;
